import React, { useState } from "react";
import '../assets/css/ToggleSwitch.css';

const NotificationToggle = ({ label = "Toggle", checked, onChange, variant, fullWidth = true, disabled = false }) => {
  const [internalChecked, setInternalChecked] = useState(false);
  const isControlled = checked !== undefined;
  const isChecked = isControlled ? checked : internalChecked;

  const handleChange = (e) => {
    const value = e.target.checked;
    if (!isControlled) setInternalChecked(value);
    onChange?.(value);
  };

  const handleReset = () => {
    if (!isControlled) setInternalChecked(false);
    onChange?.(false);
  };

  return (
    <div className={`d-flex justify-content-between align-items-center ${fullWidth ? "w-100" : ""} switchbtn ${variant ? `switch-${variant}` : ""}`}>
      {label && (
        <div>
          <button onClick={handleReset}></button>
          <span className="lablename">{label}</span>
        </div>
      )}


    <div>
      <input
        type="checkbox"
        className=""
        checked={isChecked}
        onChange={handleChange}
        disabled={disabled}
        aria-label={label || "Toggle setting"}
      />

      {isChecked && <span className="checkon"></span>}
    </div>
    </div>
  );
};

export default NotificationToggle;



